import { ADVANCE_PAYMENT_BREAKUP_ACTION_STATE } from 'actions/PaymentActions/PaymentActions';
import { INIT } from 'utils/asyncStatusHelper';
import { createReducer } from 'utils/reducerUtils';

export const INITIAL_STATE = { asyncStatus: INIT };

export default createReducer(
	ADVANCE_PAYMENT_BREAKUP_ACTION_STATE.REQUEST,
	ADVANCE_PAYMENT_BREAKUP_ACTION_STATE.SUCCESS,
	ADVANCE_PAYMENT_BREAKUP_ACTION_STATE.ERROR,
	INITIAL_STATE
);
